import React from 'react';
import { Worker, Viewer, RenderPageProps } from '@react-pdf-viewer/core';

interface IPDFViewerProps {
    signedUrl: string;
    scale: number;
};
export const PDFViewer = (props: IPDFViewerProps) => {
    const { signedUrl, scale } = props;

    const renderPage = (props: RenderPageProps) => {
        const { canvasLayer, textLayer, annotationLayer } = props;

        return (
            <div className='immersion__pdf_viewer__content_main'>
                {canvasLayer.children}
                <div style={{ display: 'none' }}>
                    {textLayer.children}
                </div>
                {annotationLayer.children}
            </div>
        );
    };

    const renderLoader = () => {
        return (
            <div className='immersion__pdf_viewer__content_loading'>
                <span className='immersion__btn_loader immersion__btn_loader__primary' />
                <span>Loading PDF</span>
            </div>
        );
    };

    return (
        <div className='immersion__pdf_viewer'>
            <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                <Viewer
                    defaultScale={scale}
                    renderLoader={renderLoader}
                    renderPage={renderPage}
                    fileUrl={`${process.env.REACT_APP_API_URL}/misc/pdf-content?signedUrl=${encodeURIComponent(signedUrl)}`}
                />
            </Worker>
        </div>
    );
};